import { render, staticRenderFns } from "./ModalResponsive.vue?vue&type=template&id=58aa67d5&scoped=true"
import script from "./ModalResponsive.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalResponsive.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ModalResponsive.vue?vue&type=style&index=0&id=58aa67d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@2.7.16_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vu_qgmhcv2zwyplqohcijlq2qcl3q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aa67d5",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../node_modules/.pnpm/@quasar+app@2.4.4_@vue+compiler-sfc@2.7.16_lodash@4.17.21_prettier@2.8.8/node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QInnerLoading});
